import { IContent } from "@kunduz/data-access-cms-api";
import { useAppContext } from "@kunduz/feature-website-context";
import { SegmentedPricing } from "@kunduz/ui-components";
import { useRouter } from "next/router";
import React, { ReactElement, useEffect, useState } from "react";
import {
  PageviewEvents,
  sendViewContentDatalayerEvent,
  trackEventNext,
} from "@kunduz/utility-analytics";

export const PricingWithContext = (props: Props): ReactElement => {
  const { student } = useAppContext();
  const router = useRouter();
  const yearlyPriceGroup = props.periodGroups[0];
  const defaultSelectedGradeGroup = props.gradeGroups[0];
  const [periodType, setPeriodType] = useState(yearlyPriceGroup?.id || 1);
  const [grade, setGrade] = useState(defaultSelectedGradeGroup?.id);

  useEffect(() => {
    if (!student.data && !router.query.package_group) return;

    if (student.data?.path_group?.id) {
      const _gg = props.gradeGroups.find(
        (gg) =>
          gg.path_group_id?.includes(student.data?.path_group?.id as number),
      );
      if (_gg) {
        setGrade(_gg.id);
      }
    } else if (router.query.package_group) {
      const _gg = props.gradeGroups.find(
        (gg) => gg.slug == router.query.package_group,
      );
      if (_gg) {
        setGrade(_gg.id);
      }
    }
  }, [student.data, router.query.package_group]);

  const handleViewEvent = (_plans: IContent.PlanV2CardType[]) => {
    if (!_plans || _plans.length === 0) return;

    const kunduz_event_id = PageviewEvents.sendPageViewWithEventName(
      "packages_page_visited",
    );

    sendViewContentDatalayerEvent({
      content_type: "product_group",
      content_ids: _plans.map((p) => p.package_id + ""),
      kunduz_event_id,
    } as any);

    trackEventNext({
      event: "Packages Page Visited",
      kunduz_event_id,
    });
  };

  return (
    <SegmentedPricing
      title={props.title}
      badgeText={props.badgeText}
      badgeIcon={props.badgeIcon}
      desc={props.desc}
      gradeGroups={props.gradeGroups}
      periodGroups={props.periodGroups}
      plans={props.plans}
      priceSwitchText={props.priceSwitchText}
      benefitTitle={props.benefitTitle}
      grade={grade}
      setGrade={setGrade}
      periodType={periodType}
      setPeriodType={setPeriodType}
      hideGradeGroups={!props.enableGradeGroups}
      hidePeriodGroups={!props.enablePeriodGroups}
      handleViewEvent={handleViewEvent}
    />
  );
};

interface Props {
  name?: string;
  badgeIcon: React.ElementType;
  badgeText: string;
  title: string;
  desc: string;
  priceSwitchText: string;
  periodGroups: {
    id: number;
    name: string;
    highlight_text_color: string;
  }[];
  gradeGroups: IContent.PricingComponentData["grade_groups"];
  plans: IContent.PricingComponentData["prices"];
  benefitTitle: string;
  enableGradeGroups: boolean;
  enablePeriodGroups: boolean;
  lang: "tr" | "en";
}
